export const PRIVACY_POLICY_URL =
  'https://www.metlife.com/about-us/privacy-policy/online-privacy-policy/';

export const PRIVACY_REQUEST_URL = 'https://www.metlife.com/privacy-request';

export const TERMS_OF_SERVICE_URL = 'https://www.metlife.com/about-us/terms-and-conditions/';
